import NotFound from '../layout/NotFound'; 
import React from 'react';
import { useLocation, Route, Routes } from 'react-router-dom';

const NotFoundRoute = () => {
  const location = useLocation();

  const isRoute = [
    '/', 
    '/sec/log-in',
    '/sec/create-account',
    '/sec/forgot-password',
    '/sec/verify',
    '/sec/verify/:token',
    '/sec/reset-password/:token',
    '/p/profile',
    '/event/:id/get-ticket',
    '/tickets',
    '/preview/:id',
    '/event/:id',
    '/terms-and-conditions',
    '/end-user-license-agreement',
    '/return-refund-policy',
    '/faqs',
    '/privacy-policy',
    '/p/profile',
    



  ].some((path) => location.pathname.match(new RegExp(`^${path.replace(/:[^/]+/g, '[^/]+')}$`)));

  return !isRoute ? (
    <Routes>
      <Route path="*" element={<NotFound />} />
    </Routes>
  ) : null;
};

export default NotFoundRoute;
